import React, { ErrorInfo } from "react";
import { Alert, Button } from "antd";

import {
  RATE_LIMIT_ERROR_MESSAGE,
  wasRateLimitErrorRecently,
} from "utils/networkErrors";

type Props = {
  children: React.ReactNode;
};

type State = {
  error?: Error;
};

class NetworkErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Unable to render the application", error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ error: undefined });
  };

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (!error) return children;

    const rateLimited = wasRateLimitErrorRecently();
    const errorMessage = rateLimited
      ? RATE_LIMIT_ERROR_MESSAGE
      : "We couldn't display this page. Please wait a moment and try again.";

    return (
      <div style={{ margin: "64px auto", maxWidth: 640, padding: "0 24px" }}>
        <Alert
          action={
            <Button onClick={this.handleRetry} size="small">
              Try again
            </Button>
          }
          message={errorMessage}
          showIcon
          type="error"
        />
      </div>
    );
  }
}

export default NetworkErrorBoundary;
